/* eslint-disable indent */
import { getAgeCategory } from '@src/utils/age-ratios-format';

export const getInsurancePersonTitle = (ageMin: number) => {
  const ageCategory = getAgeCategory();

  if (ageMin === 1) {
    return ageCategory.children;
  }

  return ageCategory.adults;
};
